import {
  SET_COLLEAGUES_LIST,
  SET_COLLEAGUES_STATUS,
  RESET_COLLEAGUES_STATE,
  SET_COLLEAGUES_CALL_RINGING,
  SET_COLLEAGUES_CALL_IN_PROGRESS,
  SET_COLLEAGUES_CALL_HANGUP,
  SHOW_COLLEAGUES_CALL_RINGING_CARD,
  SHOW_COLLEAGUES_CALL_INPROGRESS_CARD,
  SET_COLLEAGUES_CALL_STATUS,
  RESET_COLLEAGUES_CALL_CARDS,
} from '../../mutation-types';
import {
  getColleaguesList,
  getColleaguesListStatus,
  call,
  hangupCall,
} from '@/services/colleagues-service';
import UserService from '@/services/user-service';
import { notify } from '@/shared/utils/browser-notify';

const actions = {
  getColleaguesList({ commit, rootState }, params) {
    params.username = rootState.attendance.Attendance.agentId.toString();

    getColleaguesList(params).then((response) => {
      commit(SET_COLLEAGUES_LIST, response);
    });
  },
  getColleaguesStatus({ commit, rootState }, params) {
    params.username = rootState.attendance.Attendance.agentId.toString();

    if (params.extenList.length > 0) {
      getColleaguesListStatus(params).then((response) => {
        commit(SET_COLLEAGUES_STATUS, response);
      });
    }
  },
  call({ rootState }, params) {
    params.from = rootState.attendance.Attendance.agentId.toString();

    call(params).then((response) => {
      console.log('RESPONSE CALL SERVICE ->', response);
    });
  },
  hangupCall({ rootState }) {
    let params = {};
    params.from = rootState.attendance.Attendance.agentId.toString();

    hangupCall(params).then((response) => {
      console.log('RESPONSE HANGUP SERVICE ->', response);
    });
  },

  async setInternalCall({ commit, rootState }, params) {
    commit(SHOW_COLLEAGUES_CALL_RINGING_CARD, true);

    const agentId = rootState.attendance.Attendance.agentId.toString();

    const isCaller = params.from == agentId;
    params.isCaller = isCaller;

    if (isCaller) {
      await UserService.getUserDetails(params.to).then((response) => {
        console.log(response);
        commit(SET_COLLEAGUES_CALL_RINGING, {
          status: params,
          colleagueInfo: response.data,
        });
      });
    } else {
      await UserService.getUserDetails(params.from).then((response) => {
        console.log(response);
        commit(SET_COLLEAGUES_CALL_RINGING, {
          status: params,
          colleagueInfo: response.data,
        });

        const notification = {
          title: response.data.user_fullname,
          body: '',
          phoneNumber: '',
        };

        notify(notification, true, 'colleagues');
      });
    }
  },
  setInternalCallInProgress({ commit, rootState }, params) {
    const agentId = rootState.attendance.Attendance.agentId.toString();
    params.isCaller = params.from == agentId;
    commit(SET_COLLEAGUES_CALL_IN_PROGRESS, params);
    commit(SHOW_COLLEAGUES_CALL_INPROGRESS_CARD, true);
  },
  setInternalCallStatus({ commit, rootState }, params) {
    const agentId = rootState.attendance.Attendance.agentId.toString();
    params.isCaller = params.from == agentId;
    commit(SET_COLLEAGUES_CALL_STATUS, params);
  },
  setInternalCallHangup({ commit, rootState }, params) {
    const agentId = rootState.attendance.Attendance.agentId.toString();
    params.isCaller = params.from == agentId;
    const windowzin =
      rootState.colleagues.showColleaguesCallInProgressCard == true;
    if (windowzin) {
      commit(SET_COLLEAGUES_CALL_HANGUP, params);
      commit(SHOW_COLLEAGUES_CALL_RINGING_CARD, false);
      commit(SHOW_COLLEAGUES_CALL_INPROGRESS_CARD, false);
    } else {
      if (!params.isCaller) {
        commit(SHOW_COLLEAGUES_CALL_RINGING_CARD, false);
        commit(SHOW_COLLEAGUES_CALL_INPROGRESS_CARD, false);
      }
    }
  },
  hideColleaguesCallingCard({ commit }) {
    commit(SHOW_COLLEAGUES_CALL_RINGING_CARD, false);
  },
  resetColleaguesState({ commit }) {
    commit(RESET_COLLEAGUES_STATE);
  },
  resetDialogs({ commit }) {
    commit(RESET_COLLEAGUES_CALL_CARDS);
  },
};
export default actions;
